import datatables from 'linksoft-datatables';
import moment from 'moment';
import { localize } from 'linksoft';
import localizeResx from '../helpers/localize-resx';
import renderIcon from './pointShapeIconRenderer';

const resx = localize('App', 'Common', 'Messages');

// color change//
// https://stackoverflow.com/questions/12043187/how-to-check-if-hex-color-is-too-black
function getRGB(b) {
    let a;
    if (b && b.constructor == Array && b.length == 3) return b;
    if ((a = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(b))) {
        return [parseInt(a[1]), parseInt(a[2]), parseInt(a[3])];
    }
    if (
        (a = /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(
            b
        ))
    ) {
        return [parseFloat(a[1]) * 2.55, parseFloat(a[2]) * 2.55, parseFloat(a[3]) * 2.55];
    }
    if ((a = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(b))) {
        return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
    }
    if ((a = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(b))) {
        return [parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16), parseInt(a[3] + a[3], 16)];
    }
    return typeof colors !== 'undefined' ? colors[jQuery.trim(b).toLowerCase()] : null;
}

function luminance_get(color) {
    const rgb = getRGB(color)
    if (!rgb) {
        return null
    }
    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]
}
// color change//

const deleteButton = id => `<a data-control-button-delete="${id}" data-confirm="${resx.Messages.ConfirmDelete}" data-confirm-title="${resx.Messages.ConfirmTitle}" class="remove" href="javascript:void(0)">
              <i class="material-icons">delete</i>
              </a>`

const downloadButton = url => `<a class="download btn btn-link" title="${resx.App.Download}" href="${url}">
             <i class="material-icons">get_app</i>
           </a>`

const previewButton = (url, name) => name.endsWith('.pdf')
    ? `<a class="pdf-preview btn btn-link" title="${resx.App.Preview}" href="${url}" data-toggle="pdf-preview" ><i class="material-icons">visibility</i></a>`
    : `<a class="pdf-preview btn btn-link disabled" href="#"><i class="material-icons">visibility_off</i></a>`

const uploadButton = (url, id) => `<a data-toggle="modal" class="download btn btn-link" title="${resx.App.Reupload}" data-target="#${id}" href="${url}">
             <i class="material-icons">autorenew</i>
           </a>`

const importMeasurements = url => `<a class="btn btn-primary btn-sm float-right btn-if"
                title="${resx.App.UploadMeasurements}" href="${url}">
             <i class="material-icons">publish</i>${resx.App.UploadMeasurements}
           </a>`

export default function () {
    datatables.addTemplates({
        controlButtons(e, editUrl, showDelete) {
            return (
                `<div class="cell-edit--wrap">
                ${
                // edit
                editUrl
                    ? `<a class="edit" title="${resx.Common.Detail}" href="${linksoft.url[editUrl](
                        this
                    )}"><i class="material-icons">edit</i>${e.value}</a>`
                    : ''
                }${showDelete ? `&nbsp;${deleteButton(this.id)}` : ''}</div>`
            )
        },
        attachSensor(e, attachUrl, tableId, title) {
            return (
                `<div class="cell-edit--wrap">
                    ${`<a class="edit" title="${resx.Common.Detail}" href="${linksoft.url[attachUrl](this).replace("{pointId}", document.getElementById(tableId).getAttribute("pointid"))}">${title}</a>`
               }</div>`
            )
        },
        gisLayer(e) {
            if (e.value) {
                const name = e.value.name || e.value.nameResxKey;

                return `<span class="gis-layer-box" style="background-color:${
                    e.value.colorRgbHexCode
                    }"></span><span>${name}</span>`;
            }

            return ''
        },
        colorCell(e) {
            return `<span class="gis-layer-box" style="background-color:${
                e.value
                }"><p style="display: none">${e.value}</p></span>`;
        },
        nominalPointShape(e) {
            const enums = e.api.init().enums;

            const targetEnum = enums && e.column.options().dataType && enums[e.column.options().dataType];

            if (targetEnum) {
                const item = targetEnum.find(x => x.id === e.value || x.value === e.value);
                if (item) {
                    return `<span class='nominal-point-shape'>
                    ${renderIcon(item.id)}
                    ${item.text}
                  </span>`;
                }
            }

            return `<span>${e.value}</span>`
        },
        userAssignment(e, serviceName) {
            if ((e.value === 'NotAssigned' || e.value === 'Assigned') && !e.data.isLoggedUser) {
                const assignText = e.value === 'NotAssigned' ? resx.App.Assign : resx.App.Unassign;
                const classForLink = e.value === 'Assigned' ? 'remove' : 'add';
                return `<a class="${classForLink}" data-control-userassignment="${
                    this.id
                    }" data-control-service-name="${serviceName}" data-control-entity-id="${
                    this.entityId
                    }" href="javascript:void(0)">${assignText}</a>`;
            }
            return '';
        },
        deleteButton() {
            return deleteButton(this.id);
        },
        modalEdit(e, url, targetId, displayId) {
            return (
                '<div class="cell-edit--wrap">' +
                '<div class="cell-edit-inner">' +
                `<a data-toggle="modal" class="edit" data-target="#${targetId}" href="${linksoft.url[url](
                    this
                )}"><i class="material-icons">edit</i>${(displayId ? this.id : '')}</a>` +
                '</div>' +
                '</div>'
            );
        },
        downloadButton(e, downloadUrl, preview, upload, uploadUrl, uploadId) {
            const url = linksoft.url[downloadUrl](this);
            if (upload) {
                uploadUrl = linksoft.url[uploadUrl](this)
            }
            return downloadButton(url) + (preview ? previewButton(url, this.fileName) : '') + (upload ? uploadButton(uploadUrl, uploadId) : '')
        },
        documentDownloadButton(e, urlAttachment, urlFaceData, preview) {
            const url = linksoft.url[this.documentType === "Face"? urlFaceData: urlAttachment](this)
            return downloadButton(url) + (preview ? previewButton(url, this.fileName) : '')
            
        },

        attachmentControlButtons(e, downloadUrl) {
            const url = linksoft.url[downloadUrl](this);

            return `${deleteButton(this.id)}&nbsp;${downloadButton(url)}`;
        },
        importMeasurements(e, url) {
            return importMeasurements(linksoft.url[url](this));
        },
        warningState(e) {
            if (e.value) {
                let fontColor;
                if (luminance_get(e.value.colorRgbHexCode) < 180) {
                    fontColor = '#fff';
                } else {
                    fontColor = '#000';
                }
                return `<div class="project-warning" style="background-color:${
                    e.value.colorRgbHexCode
                    };color:${fontColor}">${localizeResx(e.value.nameResxKey)}</div>`;
            }
            return '';
        },
        matrixWarningState(e) {
            if (e.value) {
                return `<div style="color:${e.value.colorRgbHexCode};">${e.value.name}</div>`;
            }
            return '';
        },
        pointLink(e, editUrl) {
            return `<a class="edit" title="${resx.Common.Detail}" href="${linksoft.url[editUrl]({
                id: this.pointId
            })}">${e.value}</a>`;
        },
        gisButton(e, editUrl) {
            return `<a class="" title="${resx.App.Gis}" href="${linksoft.url[editUrl]({
                id: this.id
            })}"><i class="fa fa-map-o"></i></a>`;
        },
        link(e, linkUrl, propertyName, showEmpty) {
            if (e.value || showEmpty) {
                return `<a class="edit" title="${resx.Common.Detail}" href="${linksoft.url[linkUrl]({
                    id: this[propertyName]
                })}">${e.value}</a>`;
            }
            return '';
        },
        inclinationRatio(e) {
            const value = `1:${e.value}`;
            return this.inclinationLimitWarning == true
                ? `<span class="red"><i class="fa fa-exclamation-circle space-r-5"></i>${value}</span>`
                : value;
        },
        localizableText: e => localizeResx(e.value)
    });
}



// WEBPACK FOOTER //
// ./App/config/table-templates.js